import React from 'react';
import { Input, Modal, Button, Form } from 'antd';

export default Form.create()(({ onReady, form }) => {
  onReady(form);
  return (
    <Form>
      <Form.Item
        label="Name"
      >
        {
          form.getFieldDecorator('name', {
            validateFirst: true,
            rules: [{
              required: true,
              whitespace: false,
              message: 'Name cannot be left blank',
            }],
          })(<Input maxLength="64" />)
        }
      </Form.Item>
    </Form>
  );
});
